/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Q17Inputs */

const et_faq_q17 = /** @type {(inputs: Faq_Q17Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuidas tellida e-poe arendus, mis tõesti müüb?`)
};

const en_faq_q17 = /** @type {(inputs: Faq_Q17Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do I commission an e-commerce website that actually sells?`)
};

/**
* | output |
* | --- |
* | "How do I commission an e-commerce website that actually sells?" |
*
* @param {Faq_Q17Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const faq_q17 = /** @type {((inputs?: Faq_Q17Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Q17Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_faq_q17(inputs)
	return en_faq_q17(inputs)
});